import axios from "axios";
import commaSeperatedToArray from "./commaSeperatedToArray";
import setDataManagerRequired from "./setDataManagerRequired";
import { getProxyUrl } from "./serverEnvironmentConfig";

// TODO: Clear the unsused store proceedures and move them to the component that uses them

const proxyUrl = getProxyUrl();

/**
 * get the school details fromt the database
 * @param {Array.<string>} postcode single value array with a postcode string
 */
const getSchoolFromPostcode = async postcode => {
  try {
    const result = await axios.post(proxyUrl, {
      type: "json",
      method: "searchSchoolsPC",
      classname: "DbDsContacts",
      params: { postcode }
    });

    return result.data;
  } catch (error) {
    console.log("postcode search had an error :( ", error);
  }
};

/**
 * submit the user's order to the database
 * @param {object} order item of all the order details (plus user details)
 */
const submitUserOrder = async order => {
  try {
    const result = await axios.post(proxyUrl, {
      type: "json",
      method: "dbo.submitPackageOrderWithQuantities",
      classname: "DbDsWeb",
      params: order
    });

    return result.data;
  } catch (error) {
    console.log(
      "the order could not be processed, lets have a look at what we have here... ",
      error
    );
  }
};

/**
 * get the order by the md5 unique hash and display to the user their order
 * @param {string} MD5 a unique id (hash) linked to an order
 */
const getCompletedOrder = async MD5 => {
  try {
    const result = await axios.post(proxyUrl, {
      type: "json",
      method: "dbo.GetSinglePackageOrder",
      classname: "DbDsWeb",
      params: MD5
    });

    return result.data;
  } catch (error) {
    console.log(
      "The order could not be found please see the error log for more info. ",
      error
    );
  }
};

/**
 * get the package information for a given brand
 * @param {number} inv inv number
 * @param {number} sites the number code for the brand
 */
const getPackagesFromDatabase = async (inv, sites) => {
  try {
    const result = await axios.post(proxyUrl, {
      type: "json",
      method: "dbo.Web_getPackageInfoFromView",
      classname: "DbTbOnline",
      params: { inv, sites }
    });
    let { status, data } = result;
    /**
     * In this map the aim is to:
     * - format comma seperated strings into arrays
     */

    // check to make sure that the data returned is an array
    if (Array.isArray(data)) {
      console.log(typeof data);

      data = data.map(item => {
        item.packagesConflicting = commaSeperatedToArray(
          item.packagesConflicting
        );
        item.dataManagerRequired = setDataManagerRequired(
          item.productID,
          item.Name
        )
          ? 1
          : 0;
        item.productNameList = commaSeperatedToArray(item.productNameList);

        return item;
      });
    }
    const requestStage = 1;
    return { data, status, requestStage };
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      const status = error.response.status;
      const message = error.response.message;
      const requestStage = 2;
      return { status, message, requestStage };
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      // console.log(error.request);
      // console.log(error.request.status);
      const { status } = error.request;
      const message = "Please check your connection and try again";
      const requestStage = 2;
      console.log(message);
      return { status, message, requestStage };
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error", error.message);
      const requestStage = 2;
      const message = error.message;
      return { message, requestStage };
    }
  }
};

/**
 * confirm an order for activation
 * @param {Object} orderParams order information
 */
const confirmOrder = async order => {
  try {
    const result = await axios.post(proxyUrl, {
      type: "json",
      method: "DSDB.insertOrUpdateOrder",
      classname: "DbTbOnline",
      params: order
    });

    return result;
  } catch (error) {
    console.log(
      "The order could not be found please see the error log for more info. ",
      error
    );
  }
};

export {
  getSchoolFromPostcode,
  submitUserOrder,
  getCompletedOrder,
  getPackagesFromDatabase,
  confirmOrder
};
